import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { empApi, setEmployeeToken, setEmployee } from "@/lib/api";
import Logo from "@/components/Logo";

export default function EmployeeLogin() {
  const [name, setName] = useState("");
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function submit(e) {
    e?.preventDefault();
    if (!name.trim() || !pin.trim()) return toast.error("Name and PIN required");
    setBusy(true);
    try {
      const { data } = await empApi.post("/employee/login", { name: name.trim(), pin: pin.trim() });
      setEmployeeToken(data.token);
      setEmployee(data.employee);
      navigate("/employee", { replace: true });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#050505] text-white flex flex-col items-center justify-center px-4">
      <Logo size="md" />
      <div className="mt-4 text-[10px] uppercase tracking-[0.4em] text-white/50">Employee Portal</div>

      <form onSubmit={submit} className="mt-10 w-full max-w-sm bg-[#0e0e0e] border border-[#C9963F]/30 p-8" data-testid="employee-login-form">
        <div className="flex items-center gap-2 text-[#C9963F] mb-6">
          <Lock size={14} />
          <span className="text-[10px] uppercase tracking-[0.3em]">Staff Access</span>
        </div>
        <label className="block text-[10px] uppercase tracking-[0.2em] text-white/50 mb-2">Your name</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          data-testid="employee-name-input"
          className="w-full bg-transparent border-b border-white/20 px-0 py-2 mb-5 focus:border-[#C9963F] focus:outline-none text-white"
          placeholder="e.g. Aisha"
          autoFocus
        />
        <label className="block text-[10px] uppercase tracking-[0.2em] text-white/50 mb-2">PIN</label>
        <input
          type="password"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          data-testid="employee-pin-input"
          className="w-full bg-transparent border-b border-white/20 px-0 py-2 mb-8 focus:border-[#C9963F] focus:outline-none text-white tracking-widest"
          placeholder="••••"
          inputMode="numeric"
        />
        <button
          type="submit"
          disabled={busy}
          data-testid="employee-login-btn"
          className="w-full bg-[#C9963F] text-black font-medium py-3 hover:bg-[#A67A2D] disabled:opacity-60 transition-colors"
        >
          {busy ? "Signing in…" : "Enter Portal"}
        </button>
        <div className="text-center text-[10px] uppercase tracking-[0.2em] text-white/40 mt-6">
          Ask your manager if you don't have a PIN.
        </div>
      </form>
    </div>
  );
}
